import React, { Component } from 'react';
import messages from '../../../locale/messages';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../../Link';
import {
	Button,
	Accordion,
	Card
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { openDeclineReasonModal } from '../../../actions/siteadmin/modalActions';
import updateFoodStatus from '../../../actions/shop/orders/updateFoodStatus';
import updateOrderStatus from '../../../actions/shop/orders/updateOrderStatus';

import { bookingStatus } from '../../../helpers/bookingStatus';

import DeclineReasonModal from '../OrderManagement/DeclineReasonModal/DeclineReasonModal';
import CurrencyConverter from '../../CurrencyConverter';
// images
import downArrow from '../../../../public/RestaurantIcon/Dropdownwithcircle.svg';
import upArrow from '../../../../public/RestaurantIcon/Uparrowwithcircle.svg';
import ReactToPrint from 'react-to-print';
import rs from '../../../components/restaurantCommon.css';
// Config
import { api, logoUploadDir } from '../../../config';

class EaterDetails extends Component {

	static defaultProps = {
		type: 'previous',
		siteCurrency: null
	};

	constructor(props) {
		super(props);

		this.state = {
			buttonLoader: false,
			collapseID: [],
			loading: false
		};
		this.handleStatusChange = this.handleStatusChange.bind(this);
		this.renderBookingStatus = this.renderBookingStatus.bind(this);
		this.handleDeliveryStatus = this.handleDeliveryStatus.bind(this);
		this.handleButtonLoader = this.handleButtonLoader.bind(this);
		this.toggleCollapse = this.toggleCollapse.bind(this);
		this.printRef = null;
	}

	componentWillUnmount() {
		clearTimeout(this.buttonLoaderTimeout);
	}

	async handleStatusChange(id, e) {
		const { updateOrderStatus, openDeclineReasonModal } = this.props;
		let bookingStatus = e.target.value;
		if (bookingStatus === 'approved') {
			await updateOrderStatus(id, bookingStatus, 1, null, true);
		} else if (bookingStatus === 'declined') {
			await openDeclineReasonModal(id, 1);
		}
	}

	async handleDeliveryStatus(id) {
		const { updateFoodStatus } = this.props;
		const { buttonLoader } = this.state;

		if (!buttonLoader) {
			this.handleButtonLoader(id);
			await updateFoodStatus(id, true);
		}
	}

	handleButtonLoader(id) {

		this.setState({ buttonLoader: true });
		this.buttonLoaderTimeout = setTimeout(() => {
			this.setState({ buttonLoader: false });
		}, 750);
	}

	renderBookingStatus(status) {
		const { currentLocale } = this.props;
		if (status) {
			return <div>{bookingStatus(status, currentLocale)}</div>;
		}
	}

	print() {
		window.print();
	}

	toggleCollapse(id1, id2) {
		const { collapseID } = this.state;
		const index = collapseID.indexOf(id1 + '.' + id2);
		if (index > -1) {
			collapseID.splice(index, 1);
			this.setState({ collapseID });
		} else {
			collapseID.push(id1 + '.' + id2);
			this.setState({ collapseID });
		}
	}

	render() {
		const { formatMessage } = this.props.intl;
		const { type, data, updateFoodStatus, siteCurrency, siteName, intl: { locale }, logo } = this.props;

		const { buttonLoader, collapseID, loading } = this.state;
		let orderPage, pageType, deliveryOption;
		let allowedFoodStatus = ['approved', 'readyForDelivery'];

		if (type === 'previous' || type === 'upcoming') {
			orderPage = 'order-management';
			pageType = type;
		} else {
			orderPage = 'transaction';
			pageType = type == "completed" ? "completed" : "future"
		}
		if (data?.deliveryOption == 1) {
			deliveryOption = formatMessage(messages.deliveryOne)
		} else if (data?.deliveryOption == 2) {
			deliveryOption = formatMessage(messages.deliveryTwo)
		} else if (data?.deliveryOption == 3) {
			deliveryOption = formatMessage(messages.deliveryThree)
		} else {
			deliveryOption = formatMessage(messages.deliveryOne)
		}

		return (
			<div className='mainContainer' ref={el => (this.componentRef = el)}>
				{
					type === 'upcoming' && <DeclineReasonModal isOrderDetailPage={true} />
				}
				{/* <div><h1>{siteName}</h1></div> */}
				<div className='printCommonBox'>
					<img
						src={api.apiEndpoint + logoUploadDir + logo}
						alt={siteName}
						className='eaterReceiptImage'
					/>
				</div>
				{
					data && <>
						<div className='headingFlex'>
							<h1 className='eaterReceiptHeading hidden-print'><FormattedMessage {...messages.eaterReceiptDetails} /></h1>
							{
								data.bookingStatus != 'pending' && <div className='hidden-print'>
									<ReactToPrint
										trigger={() => <span></span>}
										content={() => this.componentRef}
										ref={el => (this.printRef = el)} />
									{!loading && <Button
										className={rs.btnPrimaryBorder}
										onClick={() => {
											if (this.printRef) {
												this.setState({ loading: true });
												this.printRef.handlePrint();
												this.setState({ loading: false });
											}
										}}><FormattedMessage {...messages.print} /></Button>}
								</div>
							}
						</div>
						<div className='printCommonBox'>
							<p className='eaterReceiptCommonPara printHeader'> <FormattedMessage {...messages.orderId} />: #{data.orderId}</p>
							<p className='eaterReceiptCommonPara printSubHeader'> {data?.shopDetails?.shopName ? data?.shopDetails?.shopName : ""}</p>
						</div>

						<div className='eaterReceiptTableContainer'>
							<p className='eaterReceiptCommonPara printSubHeader printCommonBox'><FormattedMessage {...messages.orderReceipt} /></p>
							{
								!loading &&
								<table className='eaterReceiptTable printOrderSection'>
									<tbody>
										{
											data && data.orderItemDetails && data.orderItemDetails.length > 0 && data.orderItemDetails.map((item, key) => {
												return (
													<tr key={key}>
														<td className='printBillAmount'>
															<div>
																<span className='eaterReceiptFoodQuantity'>{item.quantity} x </span>
																<span >{item.itemName}</span>
															</div>
															{
																item.orderModifierGroup && item.orderModifierGroup.length > 0 && item.orderModifierGroup.map((groupData, key2) => {
																	return (
																		<div className='orderAccordion'>
																				<Accordion defaultActiveKey="0" >
																					<Card>
																						<Card.Header>
																							<Accordion.Toggle variant="link" eventKey="0" onClick={() => this.toggleCollapse(key, key2)} className='arrowBtn eaterAccordionButton'>
																								<img className='accordionArrow printArrow' src={collapseID.includes(key + '.' + key2) ? downArrow : upArrow} />
																								<span className='printAccordionText' >
																									{groupData.modifierName} {' '}
																									{groupData.total > 0 && (groupData.total.toFixed(2) >= 0.01) && <span>(<CurrencyConverter
																										from={groupData.currency}
																										to={siteCurrency}
																										amount={groupData.total}
																									/>) </span>}
																								</span>
																							</Accordion.Toggle>
																						</Card.Header>
																						<Accordion.Collapse eventKey="0">
																							<Card.Body >
																								{
																									groupData.orderModifierItem && groupData.orderModifierItem.length > 0 && groupData.orderModifierItem.map((itemData, key) => {
																										return (
																											<div className='printAccordionText'>
																												<span className='accordionCount' >{itemData.quantity} x </span>
																												<span >{itemData.modifierItemName}
																													{(itemData.modifierItemPrice && (itemData.modifierItemPrice.toFixed(2) >= 0.01)) && <span> - (<CurrencyConverter
																														from={itemData.currency}
																														to={siteCurrency}
																														amount={itemData.modifierItemPrice}
																													/>)</span>}
																												</span>
																											</div>
																										)
																									})
																								}
																							</Card.Body>
																						</Accordion.Collapse>
																					</Card>
																				</Accordion>
																		</div>
																	);
																})
															}

														</td>
														<td className='printBillAmount'>
															<CurrencyConverter
																from={data.currency}
																to={siteCurrency}
																amount={item.total}
															/>
														</td>
													</tr>
												)
											})
										}
										<tr>
											<td className='printBillAmount'>
												<span><FormattedMessage {...messages.subTotalEater} /></span>
											</td>
											<td className='printBillAmount'>
												<CurrencyConverter
													from={data.currency}
													to={siteCurrency}
													amount={data.subTotal}
												/>
											</td>
										</tr>
										{data?.bookingFee > 0 && <tr>
											<td className='printBillAmount'>
												<span><FormattedMessage {...messages.bookingFee} /></span>
											</td>
											<td className='printBillAmount'>
												<CurrencyConverter
													from={data.currency}
													to={siteCurrency}
													amount={data.bookingFee}
												/>
											</td>
										</tr>}
										{data?.isFreeDelivery == true ?
											<tr>
												<td className='printBillAmount'>
													<span><FormattedMessage {...messages.deliveryFare} /></span>
												</td>
												<td className='printBillAmount'>
													<span><FormattedMessage {...messages.freeLabelEater} /></span>
												</td>
											</tr> :
											<tr>
												<td className='printBillAmount'>
													<span><FormattedMessage {...messages.deliveryFare} /></span>
												</td>
												<td className='printBillAmount'>
													<CurrencyConverter
														from={data.currency}
														to={siteCurrency}
														amount={data?.deliveryFee}
													/>
												</td>
											</tr>}
										<tr className='eaterReceiptTotalRow'>
											<td className='printBillAmount'>
												<span><FormattedMessage {...messages.total} /></span>
											</td>
											<td className='printBillAmount'>
												<CurrencyConverter
													from={data.currency}
													to={siteCurrency}
													amount={data?.userPayableFare}
												/>
											</td>
										</tr>
									</tbody>

								</table>
							}
						</div>
						<div>
							<p className='eaterReceiptCommonPara printPara'>{deliveryOption}</p>
							<p className='eaterReceiptCommonParaTwo printPara printDeliveryInstruction'>{data?.deliveryInstruction != null && data?.deliveryInstruction != "" ? data?.deliveryInstruction : <FormattedMessage {...messages.noInstructions} />}</p>
							<p className='eaterReceiptCommonParaTwo printPara printWidth' ><FormattedMessage {...messages.eaterReciptMessage} /></p>
						</div>
						<div className='eaterReceiptBackBtn hidden-print'>
							{!loading && <Link className={rs.btnPrimaryBorder} to={`/restaurant/${orderPage}/${pageType}`} ><FormattedMessage {...messages.back} /></Link>}
						</div>
					</>
				}
			</div>
		);
	}
};

const mapState = (state) => ({
	siteCurrency: state.siteSettings?.data?.currency,
	currentLocale: state.intl.locale,
	siteName: state.siteSettings.data.siteName,
	logo: state.siteSettings.data.homeLogo,
})

const mapDispatch = {
	updateOrderStatus,
	openDeclineReasonModal,
	updateFoodStatus,

}

export default injectIntl(withStyles(rs)(connect(mapState, mapDispatch)(EaterDetails)));